import { TestIdDomain } from 'constants/testIds';

const FormsTestIdsScope = {
  ADD_FORM_BUNDLE_FORM: 'add-form-bundle-form',
  COPY_FORM_BUNDLE_FORM: 'copy-form-bundle-form',
  FORMS: 'forms',
  FORMS_TREE: 'forms-tree',
  FORM_BUILDER: 'form-builder',
  FORM_VIEWER: 'form-viewer',
  PDF_EDITOR: 'pdf-editor',
  FORM_BUNDLES_LIST: 'form-bundles-list',
  FORM_BUNDLE_EDIT_FORM: 'form-bundle-edit-form',
  FORM_BUNDLE_FORMS: 'form-bundle-forms',
  FORM_BUNDLE_FORM_MODAL: 'form-bundle-form-modal',
  FORM_BUNDLE: 'form-bundle',
  FORM_BUNDLE_TESTING_TOOL: 'form-bundle-testing-tool',
  FORM_PREVIEW: 'form-preview',
};

export const FormsTestIds = {
  // FormsPage
  PAGE_TITLE: `${TestIdDomain.FORMS}.page-title`,

  // FormPreview
  PREVIEW_JURISDICTION: `${TestIdDomain.FORMS}.${FormsTestIdsScope.FORM_PREVIEW}-jurisdiction`,
  PREVIEW_JURISDICTION_STATE_AUTOCOMPLETE: `${FormsTestIdsScope.FORM_PREVIEW}.jurisdiction-state-autocomplete`,
  PREVIEW_JURISDICTION_COUNTY_AUTOCOMPLETE: `${FormsTestIdsScope.FORM_PREVIEW}.jurisdiction-county-autocomplete`,
  PREVIEW_BLOCK_NOTICE: `${TestIdDomain.FORMS}.${FormsTestIdsScope.FORM_PREVIEW}-block-notice`,

  // AddFormBundle
  ADD_FORM_BUNDLE_FORM: `${TestIdDomain.FORMS}.${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}`,
  ADD_FORM_BUNDLE_FORM_NAME_INPUT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.name-input`,
  ADD_FORM_BUNDLE_FORM_DAYS_INPUT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.days-input`,
  ADD_FORM_BUNDLE_FORM_IS_ACKNOWLEDGE_CHECKBOX: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.is-acknowledge-checkbox`,
  ADD_FORM_BUNDLE_FORM_DRAFT_CHECKBOX: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.draft-checkbox`,
  ADD_FORM_BUNDLE_FORM_CAN_BE_DELAYED_CHECKBOX: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.can-be-delayed-checkbox`,
  ADD_FORM_BUNDLE_FORM_SHOULD_BE_SIGNED_CHECKBOX: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.should-be-signed-checkbox`,
  ADD_FORM_BUNDLE_FORM_WITH_PAGE_NUMBERS_CHECKBOX: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.with-page-numbers-checkbox`,
  ADD_FORM_BUNDLE_FORM_SUBMIT_BUTTON: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.submit-button`,

  // FormBundle
  FORM_BUNDLE_EDIT_BUNDLE_NAME_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE}.edit-bundle-name-button`,
  FORM_BUNDLE_DELETE_BUNDLE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE}.delete-bundle-button`,
  FORM_BUNDLE_COPY_BUNDLE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE}.copy-bundle-button`,

  // CopyFormBundleModal
  COPY_FORM_BUNDLE_FORM: `${TestIdDomain.FORMS}.${FormsTestIdsScope.COPY_FORM_BUNDLE_FORM}`,
  COPY_FORM_BUNDLE_FORM_NAME_INPUT: `${FormsTestIdsScope.COPY_FORM_BUNDLE_FORM}.name-input`,
  COPY_FORM_BUNDLE_FORM_SUBMIT_BUTTON: `${FormsTestIdsScope.COPY_FORM_BUNDLE_FORM}.submit-button`,

  // FormBundleEditModal
  FORM_BUNDLE_EDIT_FORM: `${TestIdDomain.FORMS}.${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}`,
  FORM_BUNDLE_EDIT_FORM_NAME_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.name-input`,
  FORM_BUNDLE_EDIT_FORM_IS_ACKNOWLEDGE_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.is-acknowledge-checkbox`,
  FORM_BUNDLE_EDIT_FORM_DRAFT_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.draft-checkbox`,
  FORM_BUNDLE_EDIT_FORM_CAN_BE_DELAYED_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.can-be-delayed-checkbox`,
  FORM_BUNDLE_EDIT_FORM_SHOULD_BE_SIGNED_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.should-be-signed-checkbox`,
  FORM_BUNDLE_EDIT_FORM_WITH_PAGE_NUMBERS_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.with-page-numbers-checkbox`,
  FORM_BUNDLE_EDIT_FORM_SUBMIT_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.submit-button`,

  // FormBundleFormModal
  FORM_BUNDLE_FORM_MODAL: `${TestIdDomain.FORMS}.${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}`,
  FORM_BUNDLE_FORM_MODAL_SUBMIT_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.submit-button`,

  // FormBundleForms
  FORM_BUNDLE_FORMS_ADD_FORM_TO_BUNDLE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.add-form-to-bundle-button`,
  FORM_BUNDLE_FORMS_LIST: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.list`,
  FORM_BUNDLE_FORMS_EDIT_CONDITION_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.edit-condition-button`,
  FORM_BUNDLE_FORMS_DELETE_CONDITION_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.delete-condition-button`,
  FORM_BUNDLE_FORMS_ADD_DOCUMENT_TYPE_TO_BUNDLE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.add-document-type-to-bundle-button`,
  FORM_BUNDLE_FORMS_ELEMENT_TYPE: `${FormsTestIdsScope.FORM_BUNDLE_FORMS}.element-type-text`,

  // FormBundleTestingTool
  FORM_BUNDLE_TESTING_TOOL_PRIMARY_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.primary-checkbox`,
  FORM_BUNDLE_TESTING_TOOL_INCLUDE_SPOUSE_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.include-spouse-checkbox`,
  FORM_BUNDLE_TESTING_TOOL_INCLUDE_CO_BORROWER_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.include-co-borrower-checkbox`,
  FORM_BUNDLE_TESTING_TOOL_INCLUDE_NON_BORROWER_CHECKBOX: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.include-non-borrower-checkbox`,
  FORM_BUNDLE_TESTING_TOOL_FORM_BUNDLE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.form-bundle-select`,
  FORM_BUNDLE_TESTING_TOOL_CITY_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.city-input`,
  FORM_BUNDLE_TESTING_TOOL_STATE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.state-select`,
  FORM_BUNDLE_TESTING_TOOL_ZIP_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.zip-input`,
  FORM_BUNDLE_TESTING_TOOL_PROPERTY_TYPE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.property-type-select`,
  FORM_BUNDLE_TESTING_TOOL_PROPERTY_OCCUPANCY_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.property-occupancy-select`,
  FORM_BUNDLE_TESTING_TOOL_LOAN_PURPOSE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.loan-purpose-select`,
  FORM_BUNDLE_TESTING_TOOL_PROGRAM_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.program-select`,
  FORM_BUNDLE_TESTING_TOOL_SUBMIT_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.submit-button`,
  FORM_BUNDLE_TESTING_TOOL_CLEAR_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.clear-button`,
  FORM_BUNDLE_TESTING_TOOL_DOWNLOAD_BUTTON: `${FormsTestIdsScope.FORM_BUNDLE_TESTING_TOOL}.download-button`,

  // FormsTreeView Header
  FORMS_TREE_HIDE_EMPTY_CHECKBOX: `${FormsTestIdsScope.FORMS_TREE}.hide-empty-checkbox`,

  // PdfEditor
  PDF_EDITOR_ADD_DYNAMIC_FIELD_BUTTON: `${FormsTestIdsScope.PDF_EDITOR}.add-dynamic-field-button`,
  PDF_EDITOR_ADD_SIGN_TAG_BUTTON: `${FormsTestIdsScope.PDF_EDITOR}.add-sign-tag-button`,
  PDF_EDITOR_ADD_DYNAMIC_FIELD_MENU_BUTTON: `${FormsTestIdsScope.PDF_EDITOR}.add-dynamic-field-menu-button`,
  PDF_EDITOR_ADD_DYNAMIC_FIELD_MENU_ITEM: `${FormsTestIdsScope.PDF_EDITOR}.add-dynamic-field-menu-item`,
  PDF_EDITOR_BATCH_ADD_DYNAMIC_FIELDS_MENU_ITEM: `${FormsTestIdsScope.PDF_EDITOR}.batch-add-dynamic-fields-menu-item`,
  PDF_EDITOR_BATCH_ADD_PANEL: `${FormsTestIdsScope.PDF_EDITOR}.batch-add-panel`,
  PDF_EDITOR_BATCH_ADD_DRAG_HANDLE: `${FormsTestIdsScope.PDF_EDITOR}.batch-add-drag-handle`,
  PDF_EDITOR_BATCH_ADD_COUNT: `${FormsTestIdsScope.PDF_EDITOR}.batch-add-count`,
  PDF_EDITOR_BATCH_ADD_DONE_BUTTON: `${FormsTestIdsScope.PDF_EDITOR}.batch-add-done-button`,

  // FormViewer
  FORM_VIEWER_BACK_BUTTON: `${FormsTestIdsScope.FORM_VIEWER}.back-button`,

  // Dynamic action-button getters (icon-keyed, kept two-segment)
  getFormBuilderActionButtonId: icon =>
    `${FormsTestIdsScope.FORM_BUILDER}.${icon.replaceAll('_', '-')}-button`,
  getFormViewerActionButtonId: icon =>
    `${FormsTestIdsScope.FORM_VIEWER}.${icon.replaceAll('_', '-')}-button`,
  getPdfEditorActionButtonId: icon =>
    `${FormsTestIdsScope.PDF_EDITOR}.${icon.replaceAll('_', '-')}-button`,

  // FormBundlesList
  FORM_BUNDLES_LIST_SEARCH_INPUT: `${FormsTestIdsScope.FORM_BUNDLES_LIST}.search-input`,
  FORM_BUNDLES_LIST_CREATE_NEW_BUNDLE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLES_LIST}.create-new-bundle-button`,
  FORM_BUNDLE_RESET_OVERRIDE_BUTTON: `${FormsTestIdsScope.FORM_BUNDLES_LIST}.reset-override-button`,
  FORM_BUNDLES_LIST: 'form-bundles.list',
  FORM_BUNDLES_PAGE_TITLE: 'form-bundles.page-title',

  // FormListItem
  FORM_LIST_ITEM_DELETE_BUTTON: 'form-list-item.delete-button',

  // Dynamic
  getFormsListItemAreaId: areaCode => `${FormsTestIdsScope.FORMS}.list-item-area-${areaCode}`,
  getFormsListItemFormId: formId => `${FormsTestIdsScope.FORMS}.list-item-form-${formId}`,

  // FormBundle (inline)
  FORM_BUNDLE_SEARCH_FORM_BUNDLE_FORM_INPUT: `${FormsTestIdsScope.FORM_BUNDLE}.search-form-bundle-form-input`,

  // FormBundleFormModal (inline)
  FORM_BUNDLE_FORM_MODAL_STATE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.state-select`,
  FORM_BUNDLE_FORM_MODAL_FORM_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.form-select`,
  FORM_BUNDLE_FORM_MODAL_DOCUMENT_TYPE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.document-type-select`,
  FORM_BUNDLE_FORM_MODAL_DOCUMENTS_TO_SEND_RADIO_GROUP: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.documents-to-send-radio-group`,
  FORM_BUNDLE_FORM_MODAL_EXPRESSION_CONTEXT_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.expression-context-select`,
  FORM_BUNDLE_FORM_MODAL_TPO_GUIDANCE: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.tpo-guidance`,
  FORM_BUNDLE_FORM_MODAL_EXPRESSION_SCHEMA_LOADING: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.expression-schema-loading`,
  FORM_BUNDLE_FORM_MODAL_EXPRESSION_CONTEXT_RESOLVING: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.expression-context-resolving`,
  FORM_BUNDLE_FORM_MODAL_EXPRESSION_CONTEXT_DETECTED: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.expression-context-detected`,
  FORM_BUNDLE_FORM_MODAL_EXPRESSION_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_FORM_MODAL}.expression-input`,

  // FormBundleEditModal (inline)
  FORM_BUNDLE_EDIT_FORM_FORMS_BUNDLE_EDIT_FORM_AUTOCOMPLETE_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.forms-bundle-edit-form-autocomplete-select`,
  FORM_BUNDLE_EDIT_FORM_FORMS_BUNDLE_EDIT_FORM_AUTOCOMPLETE_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.forms-bundle-edit-form-autocomplete-input`,
  FORM_BUNDLE_EDIT_FORM_FORMS_BUNDLE_EDIT_FORM_AUTOCOMPLETE_OPTION: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.forms-bundle-edit-form-autocomplete-option`,
  FORM_BUNDLE_EDIT_FORM_BUSINESS_DAY_FORMAT_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.business-day-format-select`,
  FORM_BUNDLE_EDIT_FORM_BUSINESS_DAY_FORMAT_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.business-day-format-input`,
  FORM_BUNDLE_EDIT_FORM_BUSINESS_DAY_FORMAT_OPTION: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.business-day-format-option`,
  FORM_BUNDLE_EDIT_FORM_ACKNOWLEDGMENT_SETTINGS_SELECT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.acknowledgment-settings-select`,
  FORM_BUNDLE_EDIT_FORM_ACKNOWLEDGMENT_SETTINGS_INPUT: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.acknowledgment-settings-input`,
  FORM_BUNDLE_EDIT_FORM_ACKNOWLEDGMENT_SETTINGS_OPTION: `${FormsTestIdsScope.FORM_BUNDLE_EDIT_FORM}.acknowledgment-settings-option`,

  // AreaListItem (inline)
  CREATE_FORM_BUTTON: `${TestIdDomain.FORMS}.create-form-button`,

  // AddFormBundle (inline)
  ADD_FORM_BUNDLE_FORM_FORM_BUNDLES_CREATE_FORM_AUTOCOMPLETE_SELECT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.form-bundles-create-form-autocomplete-select`,
  ADD_FORM_BUNDLE_FORM_BUSINESS_DAY_FORMAT_SELECT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.business-day-format-select`,
  ADD_FORM_BUNDLE_FORM_ACKNOWLEDGMENT_SETTINGS_SELECT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.acknowledgment-settings-select`,
  ADD_FORM_BUNDLE_FORM_BUSINESS_DAY_FORMAT_INPUT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.business-day-format-input`,
  ADD_FORM_BUNDLE_FORM_BUSINESS_DAY_FORMAT_OPTION: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.business-day-format-option`,
  ADD_FORM_BUNDLE_FORM_ACKNOWLEDGMENT_SETTINGS_INPUT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.acknowledgment-settings-input`,
  ADD_FORM_BUNDLE_FORM_ACKNOWLEDGMENT_SETTINGS_OPTION: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.acknowledgment-settings-option`,
  ADD_FORM_BUNDLE_FORM_FORMS_BUNDLE_EDIT_FORM_AUTOCOMPLETE_INPUT: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.forms-bundle-edit-form-autocomplete-input`,
  ADD_FORM_BUNDLE_FORM_FORMS_BUNDLE_EDIT_FORM_AUTOCOMPLETE_OPTION: `${FormsTestIdsScope.ADD_FORM_BUNDLE_FORM}.forms-bundle-edit-form-autocomplete-option`,
};
